import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import ExternalLink from '../external-link/index';
import formatUrl from '../../services/format-url';
import styles from './text-editor-link.scss';

const TextEditorLink = ({ children, decoratedText, theme, ...otherProps }) =>
  <ExternalLink className={classNames(styles.container, theme)} href={formatUrl(decoratedText)} {...otherProps}>
    {children}
  </ExternalLink>;

TextEditorLink.propTypes = {
  children: PropTypes.node,
  decoratedText: PropTypes.string,
  theme: PropTypes.string,
};

export default TextEditorLink;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-link.js